import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";

import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import classes from "./refundInitiationFilterPage.module.css";
import {
  selectRefundInitiationState,
  setRefundInitiationSearchFilter,
  setRefundInitiationStatusFilter,
} from "../../../store/refund_initiation/refundFilterSlice";
import { useCallback, useEffect } from "react";

// IMPORTANT: IDs must be strings (URL params are strings)
const refundInitaiationStatusOptions = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Pending" },
  { id: "1", label: "Approved" },
  { id: "2", label: "Rejected" },
];

export const RefundInitiationFilterPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { status, search } = useSelector(selectRefundInitiationState);

  const dispatch = useDispatch();

  useEffect(() => {
    const statusParam = searchParams.get("status") ?? "";
    const searchParam = searchParams.get("search") ?? "";

    dispatch(setRefundInitiationStatusFilter(statusParam));
    dispatch(setRefundInitiationSearchFilter(searchParam));
  }, [searchParams, dispatch]);

  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "status") dispatch(setRefundInitiationStatusFilter(value));
      if (key === "search")
        dispatch(
          value
            ? setRefundInitiationSearchFilter(value)
            : setRefundInitiationSearchFilter()
        );
    },
    [dispatch, searchParams, setSearchParams]
  );

  return (
    <div className={classes.box}>
      {/* Search input */}
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      {/* Status dropdown */}
      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={refundInitaiationStatusOptions}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>
    </div>
  );
};
